import { useEffect, useState } from "react";
import { Container } from "../../../../components";
import { useForm } from "react-hook-form";
import { crearPodador } from "../handlers";
import { addYears, format } from "date-fns";
import { Form } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { schemaCreatePodador } from "../../../../schemas/validacionesPodador copy";
import Loading from "../../../../components/Loading";

export default function CreatePodador() {
  const [rta, setRta] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schemaCreatePodador),
  });

  const [fechaVencimiento, setFechaVencimiento] = useState();

  useEffect(() => {
    if (watch("fecha_inicio") && watch("fecha_inicio") != "") {
      const fechaIni = new Date(watch("fecha_inicio"));
      const fechaVto = addYears(fechaIni, 2);
      const formattFecha = format(fechaVto, "dd/MM/yyyy");
      const formatFechaForm = format(fechaVto, "yyyy-MM-dd");
      setFechaVencimiento(formattFecha);
      setValue("fecha_vencimiento", formatFechaForm);
    } else {
      setValue("fecha_vencimiento", "");
    }
  }, [watch("fecha_inicio")]);

  const enviar = async (datos) => {
    crearPodador(datos, rta, setRta, reset);
  };

  return (
    <Container linkBack={"/podadores"} titulo={"Crear Podador"}>
      <form
        onSubmit={handleSubmit(enviar)}
        className="w-100 mx-auto position-relative "
        style={{ maxWidth: "450px" }}
      >
        {rta.loading && (
          <div
            className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center top-0 "
            style={{ left: 0, background: "rgba(255,255,255,0.8)" }}
          >
            <Loading sizeIcono="50px" sizeLoad="70px" font="20px" />
          </div>
        )}
        <fieldset disabled={rta.loading} className="row">
          <Form.Group className="col-12">
            <Form.Label className="m-0">Nombre Completo:</Form.Label>
            <Form.Control
              isInvalid={!!errors.nombre}
              className="form-control"
              {...register("nombre", {
                required: "El nombre es requerido",
                minLength: {
                  value: 3,
                  message: "Minimo 3 caracteres",
                },
              })}
            />
            {errors?.nombre?.message ? (
              <Form.Control.Feedback
                className="m-0 mensajeError-sm mensajeError-md"
                type="invalid"
                style={{ height: "26px" }}
              >
                {errors?.nombre?.message}
              </Form.Control.Feedback>
            ) : (
              <div style={{ height: "26px" }} />
            )}
          </Form.Group>

          <Form.Group className="col-6">
            <Form.Label className="m-0">DNI:</Form.Label>
            <Form.Control
              isInvalid={errors?.dni}
              className="form-control"
              {...register("dni", {
                required: "El DNI es requerido",
                min: {
                  value: 1000000,
                  message: "Minimo 1000000",
                },
                max: {
                  value: 99999999,
                  message: "Maximo 99999999",
                },
              })}
              type="number"
            />
            {errors?.dni?.message ? (
              <Form.Control.Feedback
                className="m-0 mensajeError-sm mensajeError-md"
                type="invalid"
                style={{ height: "26px" }}
              >
                {errors?.dni?.message}
              </Form.Control.Feedback>
            ) : (
              <div style={{ height: "26px" }} />
            )}
          </Form.Group>
          {/* <div className="col-4">
            <label>N° Control Interno:</label>
            <input type="number" className="form-control" {...register("numero_control")} />
            <div className="mt-1" style={{ height: "26px" }}>
              {errors.numero_control && (
                <span className="text-danger">{errors.numero_control.message}</span>
              )}
            </div>
          </div> */}

          <Form.Group className="col-6">
            <Form.Label className="m-0">Teléfono:</Form.Label>
            <Form.Control
              isInvalid={!!errors.telefono}
              type="number"
              className="form-control"
              {...register("telefono")}
            />
            {errors?.telefono?.message ? (
              <Form.Control.Feedback
                className="m-0 mensajeError-sm mensajeError-md"
                type="invalid"
                style={{ height: "26px" }}
              >
                {errors?.telefono?.message}
              </Form.Control.Feedback>
            ) : (
              <div style={{ height: "26px" }} />
            )}
          </Form.Group>

          <div className="d-flex align-items-center w-100 gap-4">
            <Form.Group>
              <Form.Label className={"m-0"}>Fecha incio:</Form.Label>
              <Form.Control
                isInvalid={!!errors.fecha_inicio}
                type="date"
                className="form-control"
                {...register("fecha_inicio")}
              />
              {errors?.fecha_inicio?.message ? (
                <Form.Control.Feedback
                  className="m-0 mensajeError-sm mensajeError-md"
                  type="invalid"
                  style={{ height: "26px" }}
                >
                  {errors.fecha_inicio && (
                    <span className="text-danger">{errors.fecha_inicio.message}</span>
                  )}
                </Form.Control.Feedback>
              ) : (
                <div style={{ height: "26px" }} />
              )}
            </Form.Group>
            <Form.Group>
              <Form.Label className="m-0">Fecha vencimiento:</Form.Label>
              <div
                style={{ height: "38px" }}
                className={`d-flex align-items-center px-2 bg-secondary-subtle rounded ${
                  errors?.fecha_inicio?.message && "border border-1 border-danger"
                }`}
              >
                {watch("fecha_inicio") && fechaVencimiento}
              </div>
              <div className="" style={{ height: "26px" }}></div>
            </Form.Group>
          </div>

          <div className="col-12">
            <label>Información adicional:</label>
            <textarea className="form-control" {...register("info")} />
            <div className="mt-1" style={{ height: "26px" }}>
              {errors.info && <span className="text-danger">{errors.info.message}</span>}
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-sm btn-success d-flex">
              Crear podador
              {/* {!rta.loading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              )} */}
            </button>
          </div>
        </fieldset>
      </form>
    </Container>
  );
}
